import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles({
  chip: {
    width: 132,
    height: 43,
    fontSize: 16,
    textTransform: 'capitalize',
    borderRadius: 10,
  },
  'COMPLETED': {
    backgroundColor: '#09bd3c',
  },
  'FAILED': {
    backgroundColor: '#e02020',
  }
});
